import instance from '../utils/axios';

class CompanyService {

    async getCompanyInfoByName(name) {
        return await instance.get(`/crm/companyInfo/getCompanyByName?name=${name}`);
    }
}
export default new CompanyService();